<template>
  <div class="service">
    <span class="itService" @click="tabFlag"> IT Service </span>

    <div data-v-7ba5bd90="" v-show="flag" class="downmenu">
      <div data-v-7ba5bd90="">
        <div
          class="contact_it"
          data-v-7ba5bd90=""
          style="font-size: 12px; color: rgb(170, 170, 170); margin-left: 5px"
        >
          Contact IT
        </div>
        <a
          data-v-7ba5bd90=""
          href="https://work.weixin.qq.com/nl/innerkfid/ikfk6aOBgAAV7j1z0i-UiDAnBKkJRHbcg"
          class="contactIT-wecom"
        >
          <div data-v-7ba5bd90="" class="left" style="">
            <svg
              data-v-7ba5bd90=""
              t="1741922692839"
              viewBox="0 0 1228 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1386"
              width="50%"
              height="50%"
              class="icon"
            >
              <path
                data-v-7ba5bd90=""
                d="M1045.84 747.027a153.563 153.563 0 0 0-53.156 21.515 129.094 129.094 0 0 1-58.092 35.1c2.953-19.828 12.783-37.926 27.633-51.3a191.186 191.186 0 0 0 26.452-62.142 56.953 56.953 0 1 1 57.164 56.827zM941.639 610.634a190.814 190.814 0 0 0-61.932-26.747 56.953 56.953 0 1 1 56.953-56.953 155.266 155.266 0 0 0 21.263 53.325 129.666 129.666 0 0 1 34.762 58.346 85.978 85.978 0 0 1-50.878-27.97h-0.21z m-93.826-200.728c-17.17-143.817-166.092-256.5-346.274-256.5-191.954 0-348.132 127.744-348.132 284.85a266.33 266.33 0 0 0 124.369 216.169 351.762 351.762 0 0 0 37.969 24.384l-15.44 61.636c5.568 2.616 10.968 5.4 16.663 7.805l77.963-38.981c11.39 2.953 23.372 4.851 35.268 6.876 7.594 1.35 15.188 2.742 22.993 3.67a401.119 401.119 0 0 0 145.547-8.353 281.011 281.011 0 0 0 11.474 62.185 481.153 481.153 0 0 1-108.675 12.698 472.5 472.5 0 0 1-97.621-10.758L262.46 846.21a31.219 31.219 0 0 1-33.877-3.543 31.64 31.64 0 0 1-10.926-32.316l25.312-101.925A330.075 330.075 0 0 1 90.125 438.256c0-192.29 184.19-348.131 411.413-348.131 215.746 0 392.428 140.653 409.64 319.444a276.919 276.919 0 0 0-29.91-2.953c-11.18 0.422-22.36 1.476-33.456 3.248zM716.399 634.47c18.943-3.797 36.957-11.053 53.157-21.515a129.094 129.094 0 0 1 58.134-35.016 86.358 86.358 0 0 1-27.675 51.216c-12.445 18.984-21.389 40.078-26.451 62.184a56.953 56.953 0 1 1-57.165-56.869z m102.6 137.025c18.816 12.614 39.741 21.727 61.763 27a56.953 56.953 0 1 1-56.953 56.953 154.406 154.406 0 0 0-21.094-53.409 129.558 129.558 0 0 1-34.51-58.514 85.888 85.888 0 0 1 50.794 28.308v-0.338z"
                p-id="1387"
                fill="#2a50d7"
                class="mySvg"
              ></path>
            </svg>
          </div>
          <div data-v-7ba5bd90="" class="center">
            <p data-v-7ba5bd90="">WeCom IT Hotline</p>
            <p data-v-7ba5bd90="">
              Online communication, quick response to your questions
            </p>
          </div>
          <div data-v-7ba5bd90="" class="rigth">
            <img
              data-v-7ba5bd90=""
              src="data:image/png;base64,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"
              alt="右箭头"
            />
          </div>
        </a>
        <div data-v-7ba5bd90="" class="contactIT-hotline">
          <div data-v-7ba5bd90="" class="left">
            <svg
              data-v-7ba5bd90=""
              t="1741922670491"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1225"
              width="50%"
              height="50%"
              class="icon"
            >
              <path
                data-v-7ba5bd90=""
                d="M731.7 451.9c0 21.9 14.6 35.4 35.4 35.4 21.9 0 35.4-14.6 35.4-35.4-0.5-118.7-96.3-214.6-215.1-215.1-21.9 0-35.4 14.6-35.4 35.4 0 21.9 14.6 35.4 35.4 35.4 79.7 0.5 143.8 64.6 144.3 144.3z m143.2 0c0 21.9 14.6 35.4 35.4 35.4s35.4-14.6 35.4-35.4c0-197.4-162-358.3-358.3-358.3-21.9 0-35.4 14.6-35.4 35.4s14.6 35.4 35.4 35.4c158.3 0 287.5 129.7 287.5 287.5zM390.6 326.4c39.6-39.6 42.7-100.5 7.3-143.2l-111-140.7C251.5-4.3 182.8-11.6 136.4 24.8c-3.1 3.1-7.3 3.1-7.3 7.3L31.8 129C-60.9 221.7 71.4 473.2 312 713.8s488 369.7 581.2 279.7l96.9-96.9c42.7-42.7 42.7-110.9 0-150.5l-7.3-7.3-140.2-110.9c-42.7-35.4-103.6-32.3-143.2 7.3l-60.9 60.9c-64.6-39.6-122.4-82.3-172.4-132.8-50-50.5-92.7-107.8-132.3-172.4-1-0.5 56.8-64.5 56.8-64.5zM340.1 229c10.4 14.6 10.4 35.4-3.1 46.9l-79.2 82.8c-11.5 11.5-14.1 28.6-7.3 42.7 42.2 78.1 95.8 148.9 157.8 212 62.5 62.5 133.8 115.6 212 157.8 14.6 6.8 31.8 4.2 42.7-7.3l82.3-82.3c14.6-14.6 32.3-14.6 46.9-3.1l140.1 115.1s3.1 0 3.1 3.1c14.1 13 14.6 34.9 1.6 49l-1.6 1.6-97 96.7c-46.9 46.9-268.7-71.9-480.7-279.7C146.8 455 31.8 229 78.6 182.1L179.1 81.6c14.6-10.4 39.6-10.4 50 7.3l111 140.1z"
                fill="#2a50d7"
                p-id="1226"
              ></path>
            </svg>
          </div>
          <div data-v-7ba5bd90="" class="center">
            <p data-v-7ba5bd90="">IT Hotline Tel</p>
            <p data-v-7ba5bd90="">
              Please call the hotline +86 400 818 2222 for urgent matters
            </p>
          </div>
          <div data-v-7ba5bd90="" class="rigth"></div>
        </div>
        <a
          href="mailto:ithotline@h3c.com"
          data-v-7ba5bd90=""
          class="contactIT-email"
        >
          <div data-v-7ba5bd90="" class="left">
            <svg
              data-v-7ba5bd90=""
              t="1741922571770"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1063"
              width="50%"
              height="50%"
              class="icon"
            >
              <path
                data-v-7ba5bd90=""
                d="M863.460142 234.780211c12.746302-9.595542 10.121522-17.447371-5.832845-17.447371l-693.052542 0c-15.954367 0-18.583241 7.856945-5.843078 17.45965l328.98885 247.964488c12.740162 9.602705 33.592073 9.608845 46.338375 0.013303L863.460142 234.780211z"
                fill="#2a50d7"
                p-id="1064"
                class="mySvg"
              ></path>
              <path
                data-v-7ba5bd90=""
                d="M678.609087 450.79708c-12.746302 9.595542-13.45136 26.15673-1.566682 36.801161l211.248262 189.215456c11.883655 10.643408 10.57587 12.375865-2.908236 3.847631L631.603517 520.147564c-13.484106-8.528234-34.942837-7.653307-47.690162 1.941212l-49.876967 37.550221c-12.746302 9.595542-33.598212 9.589402-46.338375-0.013303l-50.363038-37.960567c-12.740162-9.602705-34.192753-10.475586-47.671743-1.941212l-254.139118 160.925133c-13.478989 8.53642-14.757099 6.840802-2.838651-3.76679l212.452693-189.088566c11.917424-10.606569 11.244089-27.14115-1.496074-36.743856l-257.81381-194.320731c-12.740162-9.602705-23.164582-4.406356-23.164582 11.54801l0 562.683333c0 15.953344 13.053294 29.007661 29.007661 29.007661l838.401931 0c15.954367 0 29.007661-13.054317 29.007661-29.007661l0-562.311873c0-15.954367-10.42749-21.156856-23.173792-11.561313L678.609087 450.79708z"
                fill="#2a50d7"
                p-id="1065"
                class="mySvg"
              ></path>
            </svg>
          </div>
          <div data-v-7ba5bd90="" class="center">
            <p data-v-7ba5bd90="">IT Hotline Email</p>
            <p data-v-7ba5bd90="">ithotline@h3c.com</p>
          </div>
          <div data-v-7ba5bd90="" class="rigth">
            <img
              data-v-7ba5bd90=""
              src="data:image/png;base64,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"
              alt="右箭头"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IT_Service',
  data() {
    return {
      flag: false

    }
  },
  methods: {
    tabFlag() {
      this.flag = !this.flag
    }
  }
}
</script>

<style lang="less" scoped type="text/less">
.service {
  display: inline;
}
.itService {
  cursor: pointer;
}
.downmenu {
  padding: 10px;
  width: fit-content;
  border: 1px solid rgb(235, 238, 245);
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
  z-index: 1000;
  background-color: rgb(255, 255, 255);
  position: absolute;
  top: 72px;
  left: 1649.95px;
  .contact_it {
    font-size: 12px;
    color: rgb(170, 170, 170);
    margin-left: 5px;
  }
  .contactIT-wecom {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 5px;
    border-radius: 10px;
    .left {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: rgb(204, 204, 204);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .center {
      width: 185px;
      margin-left: 5px;
      p {
        font-size: 12px;
        margin: 5px;
        color: #515a6e;
        &:last-child {
          color: #aaa;
        }
      }
    }
    .rigth {
      img {
        width: 10px;
        height: 15px;
      }
    }
  }
  .contactIT-hotline {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .left {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: rgb(204, 204, 204);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .center {
      width: 185px;
      margin-left: 5px;
      p {
        font-size: 12px;
        margin: 5px;
        color: #515a6e;
        &:last-child {
          color: #aaa;
        }
      }
    }
    .rigth {
      width: 10px;
      height: 15px;
    }
  }
  .contactIT-email {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 5px;
    border-radius: 10px;
    .left {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: rgb(204, 204, 204);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .center {
      width: 185px;
      margin-left: 5px;
      p {
        font-size: 12px;
        margin: 5px;
        color: #515a6e;
        &:last-child {
          color: #aaa;
        }
      }
    }
    .rigth {
      img {
        width: 10px;
        height: 15px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/IT_Service.vue